import { useMatches, type UIMatch } from "react-router";

interface LandingPageHandle {
  header?: React.ComponentType;
}

export const HeaderOutlet = () => {
  const matches = useMatches() as Array<UIMatch<unknown, LandingPageHandle>>;
  const Component = matches.findLast((match) => match.handle?.header)?.handle?.header;
  return Component ? <Component /> : null;
};
